import {useGoogleLogin} from "react-google-login";
import {googleClientId} from "../../config";
export const ON_FAILURE_ERROR_MESSAGE = "Unable to log in with Google and other services when third-party cookies are blocked in your browser. Please update your browser settings in order to login with Google.";
export const useGoogle = (googleSuccess, googleFailure) => {
  return useGoogleLogin({
    accessType: "offline",
    clientId: googleClientId,
    onSuccess: (response) => {
      googleSuccess(response.tokenId);
    },
    onFailure: (error) => {
      if (error.error !== "idpiframe_initialization_failed")
        googleFailure(`${ON_FAILURE_ERROR_MESSAGE} ${error.details || ""}`);
    }
  }).signIn;
};
